import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useUpdateRoles({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    roles,
    teamId,
    userId,
  }: {
    roles: string[]
    teamId: string
    userId: string
  }) => {
    const response = await httpClient.post(
      'team/team/update-roles',
      {
        roles,
        user_id: userId,
      },
      {
        headers: {
          'X-Team': teamId,
        },
      },
    )
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
    onSuccess: (res, variables) => {
      toast.success('Roles updated successfully')
      queryClient.invalidateQueries({ queryKey: ['current-user'] })
      queryClient.invalidateQueries({ queryKey: ['users'] })
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
